import env from 'penv.macro'


const API_ENDPOINT = env({
  development: 'http://localhost:1337',
  production: '',
})


export { API_ENDPOINT }


// WEBPACK FOOTER //
// ./src/config.js